// extracted by mini-css-extract-plugin
module.exports = {"split":"NewJob_split__1Jg7u","half":"NewJob_half__2ANBC","sticky":"NewJob_sticky__11QUB"};